<template>
  <div class="d-inline-block">
    <v-btn
      size="x-small"
      color="primary"
      variant="text"
      icon="mdi-account-multiple-plus"
      aria-label="Manage members"
      @click="open"
    ></v-btn>

    <v-dialog v-model="dialog" max-width="600">
      <v-card prepend-icon="mdi-account-multiple" title="Manage members">
        <v-card-text>
          <div class="text-body-2 text-grey mb-2">
            Project: <strong>{{ project && project.title }}</strong>
          </div>
          <v-autocomplete
            prepend-inner-icon="mdi-account-multiple"
            :items="employees"
            item-title="title"
            item-value="value"
            label="Members"
            auto-select-first
            chips
            closable-chips
            v-model="people"
            multiple
          ></v-autocomplete>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text="Close" variant="plain" @click="dialog = false"></v-btn>
          <v-btn
            color="primary"
            text="Save"
            variant="flat"
            :loading="saving"
            @click="save()"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import constant from '@/constant';
import utils from '@/utils';
import apiMixin from '@/mixins/apiMixin';

export default {
  name: 'EditProjectMembers',
  mixins: [apiMixin],
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      saving: false,
      people: [],
      employees: [],
      constant: constant,
    };
  },
  methods: {
    open() {
      // Prefill with the project's current member user IDs.
      this.people = (this.project.member || []).map((m) => m.user_id);
      this.dialog = true;
      if (this.employees.length === 0) {
        this.getUsers();
      }
    },
    save() {
      this.saving = true;
      const payload = {
        id: this.project.id,
        people: this.people,
      };
      axios.post(utils._api(this.constant.update_member), payload, this.authHeaders())
        .then((response) => {
          this.saving = false;
          this.dialog = false;
          this.$emit('updated', response.data.members);
          this.$emit('toggle-message', response.data.message);
        })
        .catch(error => {
          this.saving = false;
          console.error('Error updating members:', error);
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Failed to update members';
          this.$emit('toggle-message', msg);
        });
    },
    getUsers() {
      axios.get(utils._api(this.constant.get_active_users), this.authHeaders())
        .then((response) => {
          this.employees = (response.data.data || []).map((employee) => ({
            title: employee.fullname,
            value: employee.id
          }));
        })
        .catch(error => console.error('Error fetching users:', error));
    },
  },
};
</script>
